// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var User_Type = require("./User_Type.bs.js");
var User_Storage = require("./User_Storage.bs.js");

var status = {
  contents: /* NotInitialized */1
};

function setStatus(s) {
  status.contents = s;
}

function getStatus(param) {
  return status.contents;
}

var userRef = {
  contents: User_Type.disconnected
};

function setUser(u) {
  userRef.contents = u;
  Curry._1(User_Storage.save, u);
}

function getUser(param) {
  return userRef.contents;
}

var ssoEnvRef = {
  contents: "prod"
};

function getEnv(param) {
  return ssoEnvRef.contents;
}

function setEnv(e) {
  ssoEnvRef.contents = e;
}

exports.status = status;
exports.setStatus = setStatus;
exports.getStatus = getStatus;
exports.userRef = userRef;
exports.setUser = setUser;
exports.getUser = getUser;
exports.ssoEnvRef = ssoEnvRef;
exports.getEnv = getEnv;
exports.setEnv = setEnv;
/* User_Type Not a pure module */
